<template>
  <div class="empty">
    <b-icon-archive-fill scale="4"></b-icon-archive-fill>
    <p class="text">暂无数据</p>
  </div>
</template>

<script>
export default {
  name: "app-empty",
};
</script>

<style scoped>
.empty {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  color: #ddd;
  text-align: center;
  min-height: 15rem;
}
.empty .text {
  margin-top: 30px;
}
</style>
